import { styled } from '@mui/material'

const LoadingComponent = styled('div')({
  display: 'inline-block',
  position: 'relative',
  width: 78,
  height: 13,

  '& span': {
    position: 'absolute',
    top: 0,
    width: 13,
    height: 13,
    borderRadius: '50%',
    animationTimingFunction: 'cubic-bezier(0, 1, 1, 0)',
  },
  '& span:nth-of-type(1)': {
    left: '8px',
    animation: 'lds-ellipsis1 0.6s infinite',
  },
  '& span:nth-of-type(2)': {
    left: '8px',
    animation: 'lds-ellipsis2 0.6s infinite',
  },
  '& span:nth-of-type(3)': {
    left: '32px',
    animation: 'lds-ellipsis2 0.6s infinite',
  },
  '& span:nth-of-type(4)': {
    left: '56px',
    animation: 'lds-ellipsis3 0.6s infinite',
  },
  '@keyframes lds-ellipsis1': {
    '0%': {
      transform: 'scale(0)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
  '@keyframes lds-ellipsis3': {
    '0%': {
      transform: 'scale(1)',
    },
    '100%': {
      transform: 'scale(0)',
    },
  },
  '@keyframes lds-ellipsis2': {
    '0%': {
      transform: 'translate(0, 0)',
    },
    '100%': {
      transform: 'translate(24px, 0)',
    },
  },
})

interface Props {
  color: string
}

export function Loading({ color }: Props) {
  return (
    <LoadingComponent color={color}>
      <span style={{ backgroundColor: color }} />
      <span style={{ backgroundColor: color }} />
      <span style={{ backgroundColor: color }} />
      <span style={{ backgroundColor: color }} />
    </LoadingComponent>
  )
}
